import React from 'react';
import PropTypes from 'prop-types';
import AdvTopLevelWorkflow from '../AdvWorkflow/AdvTopLevelWorkflowContainer';
import AccountsWorkflow from '../AccountsWorkflow/AccountsWorkflowContainer';
import ExpensesWorkflow from '../ExpensesWorkflow/ExpensesWorkflowContainer';
import IncomeWorkflow from '../IncomeWorkflow/IncomeWorkflowContainer';
import TaxesWorkflow from '../TaxesWorkflow/TaxesWorkflowContainer';
import StartAtRetirement from './Steps/StartAtRetirementContainer';
import AnnualExpense from './Steps/AnnualExpenseContainer';
import PersonalInfoWorkflow from '../PersonalInfoWorkflow/PersonalInfoWorkflowContainer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';

import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';

const HealthcareWorkflowView = ({
  workflowId,
  clientId,
  outputFunction,
  childFirstName,
  isMobile,
  childrenList,
  selectedGoalId,
  shouldSkipSummary,
  ...rest
}) => {
  useDocumentTitle('Save for Health Care');

  return (
    <AdvTopLevelWorkflow
      {...rest}
      selectedGoalId={selectedGoalId}
      clientId={clientId}
      hasAutoOutput={shouldSkipSummary}
      workflowId={workflowId}
      analyticsWorkflowStarted="healthcare_workflow_started"
      outputFunction={outputFunction(clientId, childrenList, childFirstName)}
      steps={[
        PersonalInfoWorkflow,
        TaxesWorkflow,
        IncomeWorkflow,
        ExpensesWorkflow,
        StartAtRetirement,
        AnnualExpense,
        AccountsWorkflow,
      ]}
    />
  );
};

HealthcareWorkflowView.propTypes = {
  outputFunction: PropTypes.func.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  childFirstName: PropTypes.string.isRequired,
  childrenList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isMobile: PropTypes.bool.isRequired,
  selectedGoalId: PropTypes.string.isRequired,
  shouldSkipSummary: PropTypes.bool.isRequired,
};

export default HealthcareWorkflowView;
